module.exports = __webpack_public_path__ + "static/img/site-web-small.4bbf4871.jpg";